/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

const BASE = "account/account-settings";

export const ACCOUNT_SETTINGS_PATHS = {
  BASE,
} as const;

export const ACCOUNT_SETTINGS_ROUTES = {
  BASE: `/${ACCOUNT_SETTINGS_PATHS.BASE}`,
  ROOT: `/${ACCOUNT_SETTINGS_PATHS.BASE}/*`,
  NAME: "Account Settings",
} as const;
